/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_296de9bb{display:block}.resizeIsShort_296de9bb{width:400px}.buttonGroup_296de9bb{margin-bottom:40px}.buttonGroup_296de9bb button{margin-right:20px}.settingsGroup_296de9bb{padding-top:20px}.itemCountDropdown_296de9bb{width:180px}\n"}]);
export const root = "root_296de9bb";
export const resizeIsShort = "resizeIsShort_296de9bb";
export const buttonGroup = "buttonGroup_296de9bb";
export const settingsGroup = "settingsGroup_296de9bb";
export const itemCountDropdown = "itemCountDropdown_296de9bb";